<template>
  <div class="table-responsive">
    <table class="table m-0 p-0 dataTable min-h-[150px] text-nowrap">
      <thead class="bg-white">
        <tr>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Name
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Storage Area Manager
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Location
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Status
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Created
          </th>
          <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
            Actions
          </th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr v-if="loading">
          <td colspan="12" class="text-center">
            <div
              class="text-center"
              style="padding-top: 100px; padding-bottom: 50px"
            >
              <span
                class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                style="font-size: 8rem"
              ></span>
              <h3
                class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                style="padding-bottom: 100px"
              >
                Please wait while we load your distributor's list
              </h3>
            </div>
          </td>
        </tr>
        <tr v-for="l in SubLocations" :key="l.id" v-else>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            <span v-if="l.name">{{ l.name }}</span>
            <span v-if="l.code">({{ l.code }})</span>
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.manager ? l.manager.displayName : "N/A" }}
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ l.location.name }}
          </td>
          <td>
            <span
              class="flex items-center gap-[4px] max-w-max w-full"
              :class="[
                'badge',
                { 'badge-success': l.active, 'badge-danger': !l.active },
              ]"
            >
              <span
                class="w-[10px] h-[10px] rounded-[1px]"
                :style="{ backgroundColor: l.active ? '#16a249' : '#EF5253' }"
              ></span>
              <span class="text-[12px] font-normal leading-[16.94px]">{{
                l.active ? "Active" : "Inactive"
              }}</span>
            </span>
          </td>
          <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
            {{ formatDate(l.created) }}
          </td>
          <td>
            <button
              class="btn-no-border"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
              >
                ...
              </span>
            </button>
            <ul
              class="dropdown-menu shadow-none"
              aria-labelledby="dropdownMenuButton"
            >
              <li
                class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                v-if="
                  hasPermission('Inventory_SubLocation_Update') &&
                    l.location.parentId == user.parentId
                "
                @click.prevent="viewEdit(l)"
              >
                Edit
              </li>
              <li
                class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                href="#"
                v-if="hasPermission('Inventory_SubLocation_Delete')"
                style="color: red"
                @click.prevent="confirmDelete(l.id)"
              >
                Delete Storage Area
              </li>
            </ul>
          </td>
        </tr>
        <tr v-if="!SubLocations.length && !loading">
          <td colspan="6">
            <div class="text-center" style="padding-top: 50px">
              <span
                style="font-size: 4.615rem"
                class="mdi mdi-crosshairs-gps"
              ></span>
            </div>
            <h3 class="text-center" style="padding-bottom: 100px">
              You don't have any storage areas.
            </h3>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
export default {
  props: [
    "SubLocations",
    "hasPermission",
    "Locations",
    "loading",
    "viewEdit",
    "confirmDelete",
  ],
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
  },
};
</script>

<style></style>
